export { default } from './BatteryCapacityFilter';
